import NotificationStatusTag from './NotificationStatusTag.component';

export default NotificationStatusTag;
